export const DEFAULT_MUSIC_COUNTRY = 'de'
